var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$apollo.loading)?_c('field-mapper',{attrs:{"page-title":"Membership Requirements","list":_vm.list,"disable-editing-fields":_vm.disableEditingFields},on:{"save":_vm.handleSave}}):_c('spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }